/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Possible positions at which to show a popup.
 *
 * The default position is CENTER which shows the popup at the center
 * of the window. Other positions are relative to the triggering element
 * (typically, but not always, a button).
 */
export let PopupPosition = /*#__PURE__*/function (PopupPosition) {
  PopupPosition["CENTER"] = "center";
  PopupPosition["FIXED"] = "fixed";
  PopupPosition["LEFT"] = "left";
  PopupPosition["RIGHT"] = "right";
  PopupPosition["ABOVE"] = "above";
  PopupPosition["BELOW"] = "below";
  return PopupPosition;
}({});
//# sourceMappingURL=PopupPosition.js.map
